module.exports = __webpack_public_path__ + "img/middle_15.bdef9fa2.png";